/** @format */

import React, { useEffect, useState, useRef, Fragment } from "react";

import "../App.css";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";

import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";
import logoHead from "./logo/cder_logo.png";
import { set } from "date-fns";
import { BrowserRouter as Router, Link } from "react-router-dom";

export const ApprenticeshipReq = () => {
  const handleButtongClick1 = () => {};

  return (
    <Fragment>
      <div className=" m-0  text-white main-banner">
        <div className="head-banner-logo">
          <img src={logoHead} alt="logoHead" />
        </div>
        <div className="banner-text-1">
          <p>
            République Algérienne Démocratique et Populaire Ministère de
            l'Enseignement Supérieur et de la Recherche Scientifique Direction
            Générale de la Recherche Scientifique et du Développement
            Technologique
          </p>
        </div>
        <div className="banner-text-2">
          <span>EPST/Centre de Développement des Energies Renouvelables</span>
        </div>
      </div>

      <div className=" apprenticeship-select-wrapper flex flex-col justify-center items-center">
        <div className="p-5">
          <h3>Demande de stage</h3>
        </div>
        <div className="apprenticeship-type-select">
          <Link
            className="border-2 border-gray-200 shadow-sm rounded-md pt-2 pb-2 text-gray-900 hover:text-white hover:bg-custom_blue2 cursor-pointer pr-2 pl-2 w-auto text-center no-underline	;
            "
            to="/ApprenticeshipReq_CFPA"
          >
            CFPA
          </Link>

          <Link
            className="border-2 border-gray-200 shadow-sm rounded-md pt-2 pb-2 text-gray-900 hover:text-white hover:bg-custom_blue2 cursor-pointer pr-2 pl-2 w-auto text-center no-underline	;
            "
            to="/ApprenticeshipReq_UNI"
          >
            Université
          </Link>
          <Link
            className="border-2 border-gray-200 shadow-sm rounded-md pt-2 pb-2 text-gray-900 hover:text-white hover:bg-custom_blue2 cursor-pointer pr-2 pl-2 w-auto text-center no-underline	;
            "
            to="/ApprenticeshipReq_UNI_CENTER"
          >
            Centre Universitaire
          </Link>
        </div>
      </div>

      {/* <footer className="main-footer">
        <div className="">
          <div className="">
            <div className="">
              <h5>About</h5>
              <p>This is the footer with some text.</p>
            </div>
          </div>
        </div>
      </footer> */}
    </Fragment>
  );
};
